import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const Loader = ({ open }) => {
    return (
        <Backdrop
            sx={{ color: 'var(--primary)', zIndex: (theme) => theme.zIndex.modal + 1 }}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};

export default Loader;
